import { render, staticRenderFns } from "./common-category.component.vue?vue&type=template&id=755ccef2&scoped=true&"
import script from "./common-category.component.ts?vue&type=script&lang=js&"
export * from "./common-category.component.ts?vue&type=script&lang=js&"
import style0 from "./common-category.component.css?vue&type=style&index=0&id=755ccef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755ccef2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VCardSubtitle,VCardText,VDivider,VIcon,VTreeview})
